import template from './coin_pull_report.html';
import controller from './coin_pull_report.controller';
import './coin_pull_report.scss';

let CoinPullReportComponent = {
  restrict: 'E',
  bindings: {
    printData: '='
  },
  template,
  controller
};

export default CoinPullReportComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/coin_pull_report.component.js